import {__debug} from "../../constants"
import API from "../../api";

export default class Config {

  constructor(store) {

    this.state = store.getState();
    this.dispatch = store.dispatch;

    this.updateSettings();

    store.subscribe(() => {
      this.state = store.getState();
      this.updateSettings();
    });
  }

  updateSettings(){
    if(__debug) {
      console.log('updateSettings');
      console.log(this.state);
    }
    this.settings = this.state.settings;
  }

  /* userdata */

  getUserdata(){
    return this.settings.userdata;
  }

  /* Sound */

  isSound(){
    return this.settings.userdata.sound;
  }

  toggleSound(){
    let sound = this.settings.userdata.sound;
    API.soundPreferences({sound: !sound}).then(res => {
      this.dispatch(window.settingsActions.setSoundEnable(!sound));
    })
  }
}
